(function () {

    'use strict';

    angular.module('Services').factory('ArchivedShipmentsTable', ArchivedShipmentsTable);

    function ArchivedShipmentsTable(Shipments, Carrier, TableLiteFactory, $filter, toastr, $q, TableHelpers) {
        return function (defaultFilters) {
            const bookingStatuses = {
                inprogress: 'Processing',
                processed: 'Completed',
                pending: 'Awaiting Booking'
            };
            let ShipmentsTableData = {
                tableName: 'ArchivedShipmentsTable',
                /*optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: '+ ADD NEW',
                        onClick: function () {

                        }
                    }]
                },*/
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtraction: true,
                    colMinWidth: '135px'
                },
                headers: [{
                    label: 'Archived Date',
                    viewName: 'lastModifiedDate',
                    filterName: 'lastModifiedDate',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: defaultFilters.lastModifiedDate ? new Date(defaultFilters.lastModifiedDate[0]) : '',
                        fromModel: defaultFilters.lastModifiedDate ? new Date(defaultFilters.lastModifiedDate[1]) : '',
                        useArray: true,
                        onSubmit: function (header) {

                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                            //sendRequest();
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CONSIGNMENT NO.',
                    viewName: 'consignmentId',
                    filterName: 'consignmentId',
                    filter: {
                        type: 'text',
                        class: 'filter-consignment-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'RECEIPT NO.',
                    viewName: 'receiptNo',
                    filterName: 'paymentDetails.receiptNumber',
                    width: '135px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'PICKUP REFERENCE NO.',
                    viewName: 'dhlBookingReferenceNo',
                    filterName: 'carrierOrderId',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        tableActions.sort(this.filterName);
                    }
                },{
                    label: 'Company',
                    viewName: 'companyName',
                    filterName: 'companyName',
                    filter: {
                        type: 'text',
                        class: 'filter-company',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: ' Office/Location',
                    viewName: 'locationName',
                    filterName: 'locationName',
                    filter: {
                        type: 'text',
                        class: 'filter-company',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Payment Type',
                    viewName: 'paymentType',
                    filterName: 'paymentDetails.paymentType',
                }, {
                    label: 'Account',
                    viewName: 'accountEmail',
                    filterName: 'userEmail',
                    filter: {
                        type: 'text',
                        class: 'filter-account',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'BOOKING STATUS',
                    viewName: 'bookingStatus',
                    filterName: 'bookingStatus',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        class: 'table-input',
                        /*items: [{
                         value: 'new',
                         viewName: 'New'
                         }, {
                         value: 'pending',
                         viewName: 'Pending'
                         }, {
                         value: 'unprocessed',
                         viewName: 'Unprocessed'
                         }, {
                         value: 'inprogress',
                         viewName: 'In Progress'
                         }, {
                         value: 'processed',
                         viewName: 'Processed'
                         }],*/
                        items: [{
                            value: 'pending',
                            viewName: 'Awaiting Booking'
                        }, {
                            value: 'inprogress',
                            viewName: 'Processing'
                        }, {
                            value: 'processed',
                            viewName: 'Completed'
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            tableActions.sendRequest(filter);
                        },
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'TRACKING NO.',
                    viewName: 'trackingNumber',
                    filterName: 'trackingNumber',
                    filter: {
                        type: 'text',
                        class: 'filter-tracking-number',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CUSTOMER REF. NO.',
                    viewName: 'customerReferences',
                    filterName: 'customerReferences',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Third Party System Reference No.',
                    viewName: 'wmsReferenceNo',
                    filterName: 'wmsReferenceNo',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function(header){
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.getExternalCarrierProfiles((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {size: 10, name: model});
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                    {
                        label: 'SERVICE PROFILE',
                        viewName: 'serviceProfileName',//to fix
                        filterName: 'serviceProfileId',//to fix
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            viewName: 'displayName',
                            filterBy: 'id',
                            items: [], //List of items shown in dropdown
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                Carrier.getServiceProfiles((data)=>{
                                    filterItems.length = 0;
                                    angular.forEach(data.content, (profile)=>{
                                        filterItems.push(profile);
                                    });
                                    filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                    defer.resolve();
                                }, (error)=>{
                                    defer.reject();
                                },{size:1000,name:model,carrierProfileId: tableActions.activeFilters.carrierProfileId});
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    }, {
                        label: 'Linked Job',
                        viewName: 'jobId',
                        filterName: 'job.id',
                        filter: {
                            type: 'text',
                            class: 'filter-customer-ref',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, {
                        label: 'Source Address',
                        viewName: 'sourceAdd'
                    }, {
                        label: 'Destination Address',
                        viewName: 'destinationAdd'
                    }, {
                        label: 'First Mile',
                        viewName: 'firstMile',
                        filterName: 'breakBulkDetails.firstMile.consignmentId',
                        width: '200px',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        }
                    }, {
                        label: 'Last Mile',
                        viewName: 'lastMile',
                        filterName: 'breakBulkDetails.lastMile.consignmentId',
                        width: '200px',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        }
                    },{
                        label: 'AMOUNT EX TAX',
                        viewName: 'amount'
                    }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: ()=>{
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                }
            };
            const tableActions = new TableLiteFactory(ShipmentsTableData,
                {
                    serviceCallback: Shipments.getArchivedShipments,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/

                if (!data)
                    return ShipmentsTableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.lastModifiedDate = $filter('bbaDate')(item.lastModifiedDate); // Format Date MM/dd/YYYY
                    item.companyName = item.company.name || 'N/A';
                    item.locationName = item.office.name ? item.office.name : 'N/A';
                    item.accountEmail = item.user.email || 'N/A';
                    item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';
                    item.trackingNumber = item.trackingNumber ? item.trackingNumber : 'N/A';
                    item.jobId = angular.getObjVal(item, 'job.jobId') || 'N/A';
                    if (item.serviceDetails) {
                        item.carrierName = {
                            type: 'logotype',
                            imgSrc: item.serviceDetails.logo
                        };
                        item.serviceName = item.serviceDetails.serviceName;
                    }
                    item.amount = Shipments.getShipmentCostFormatted(item).amountFormatted;
                    item.bookingStatus = bookingStatuses[item.bookingStatus]; // Define Booking Status
                    
                    if (angular.getObjVal(item, 'customerReferences')) {
                        item.customerReferences = item.customerReferences? item.customerReferences.join(', ') : 'N/A';
                    } else {
                        item.customerReferences = 'N/A';
                    }

                    item.wmsReferenceNo = item.wmsReferenceNo || 'N/A';
                    item.paymentType = angular.getObjVal(item, 'paymentDetails') ? 'Credit Card' : 'On Account';
                    item.dhlBookingReferenceNo = angular.getObjVal(item, 'carrierOrderId') || 'N/A';
                    item.sourceAdd = {
                        type: 'multiLine',
                        list:[
                            item.sourceAddress.addressLine1,
                            item.sourceAddress.addressLine2,
                            `${angular.getObjVal(item,'sourceAddress.location.name')}, `+
                            `${angular.getObjVal(item, 'sourceAddress.location.state.code') || angular.getObjVal(item, 'sourceAddress.location.state.name')}`+
                            `${angular.getObjVal(item, 'sourceAddress.location.code') ? '-' + angular.getObjVal(item, 'sourceAddress.location.code') : ''}, `+
                            `${angular.getObjVal(item, 'sourceAddress.location.country.code')}`
                        ]
                    };
                    item.destinationAdd = {
                        type: 'multiLine',
                        list:[
                            item.destinationAddress.addressLine1,
                            item.destinationAddress.addressLine2,
                            `${angular.getObjVal(item,'destinationAddress.location.name')}, `+
                            `${angular.getObjVal(item, 'destinationAddress.location.state.code') || angular.getObjVal(item, 'destinationAddress.location.state.name')}`+
                            `${angular.getObjVal(item, 'destinationAddress.location.code') ? '-' + angular.getObjVal(item, 'destinationAddress.location.code') : ''}, `+
                            `${angular.getObjVal(item, 'destinationAddress.location.country.code')}`
                        ]
                    };
                    item.receiptNo = angular.getObjVal(item, 'paymentDetails.receiptNumber') || 'N/A';
                    if(defaultFilters.unprocessedShipment){
                        item.href = '/unprocessed-shipment-details/' + item.id;
                    }else{
                        item.href = '/shipments/view/' + item.id;
                    }

                    item.firstMile = {
                        type: 'multiLine',
                        list: TableHelpers.buildBreakBulkDetails(angular.getObjVal(item, 'breakBulkDetails.firstMile')),
                    }
                    item.lastMile = {
                        type: 'multiLine',
                        list: TableHelpers.buildBreakBulkDetails(angular.getObjVal(item, 'breakBulkDetails.lastMile')),
                    };
                    ShipmentsTableData.data.push(item);
                });
            }
            this.tableData = ShipmentsTableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/ArchivedShipmentsTableService.js